import { useMemo } from 'react';
import { FieldType } from 'modules/domains';
import { useMappingsByDataType, Mapping } from 'api/MappingsAPI';
import { sortObjectListByKey } from 'utils/arrayHelpers';

const UNUSED_FIELD_TYPES = [
  FieldType.OBJECT,
  FieldType.NESTED,
  FieldType.UNDEFINED,
  FieldType.GEO_LOCATION,
  FieldType.KEYWORD,
];

const aggregateFieldMappings = (mappings: Mapping[]) =>
  mappings.filter(({ fieldType }) => !UNUSED_FIELD_TYPES.includes(fieldType));

export const useUserAndEventFields = () => {
  const { data = [], isLoading, isError } = useMappingsByDataType();
  const fieldMappings = useMemo(() => {
    const fields = aggregateFieldMappings(data);
    return sortObjectListByKey(fields, 'fieldName');
  }, [data, isLoading]);

  return {
    data: fieldMappings,
    isLoading,
    isError,
  };
};
